import { InlineResponse20014, InlineResponse20014FromJSON } from '../models/InlineResponse20014';
import { InlineResponse20015, InlineResponse20015FromJSON } from '../models/InlineResponse20015';
import { LeadAgreementToJSON } from '../models/LeadAgreement';
import * as runtime from '../runtime';

export interface LeadV1LeadListRequest {
  limit?: number;
  offset?: number;
}

export interface LeadV1ApproveLeadRequest {
  leadId: number;
  status: 'agreed' | 'not_agreed';
  comment?: string;
}

export class LeadApi extends runtime.BaseAPI {
  async leadV1LeadListRaw(requestParameters: LeadV1LeadListRequest): Promise<runtime.ApiResponse<InlineResponse20014>> {
    const headerParameters: runtime.HTTPHeaders = {};

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters?.limit) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters?.offset || requestParameters?.offset === 0) {
      queryParameters['offset'] = requestParameters.offset;
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/lead/v1/lead/my/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse20014FromJSON(jsonValue));
  }

  async leadV1LeadList(requestParameters: LeadV1LeadListRequest): Promise<InlineResponse20014> {
    const response = await this.leadV1LeadListRaw(requestParameters);
    return await response.value();
  }

  async leadV1ApproveLeadRaw(
    requestParameters: LeadV1ApproveLeadRequest
  ): Promise<runtime.ApiResponse<InlineResponse20015>> {
    if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
      throw new runtime.RequiredError(
        'leadId',
        'Required parameter requestParameters.leadId was null or undefined when calling leadV1ApproveLead.'
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const queryParameters: runtime.HTTPQuery = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const body: any = LeadAgreementToJSON(requestParameters);

    const response = await this.request({
      path: `/lead/v1/lead/agreement`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse20015FromJSON(jsonValue));
  }

  async leadV1ApproveLead(requestParameters: LeadV1ApproveLeadRequest): Promise<InlineResponse20015> {
    const response = await this.leadV1ApproveLeadRaw(requestParameters);
    return await response.value();
  }
}
